import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FormField } from '../components/FormField';
import { Button } from '../components/Button';
import { forgotConfirm } from '../api/auth';
import { ApiError } from '../api/client';

const PW_RE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{12,}$/;

export function ForgotConfirm() {
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const [email, setEmail] = useState(search.get('email') ?? '');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const next: Record<string, string> = {};
    if (!email.trim()) next.email = 'Enter your email.';
    if (!code.trim()) next.code = 'Enter the code from your email.';
    if (!PW_RE.test(password)) next.password = 'At least 12 characters, with upper, lower, digit and symbol.';
    setErrors(next);
    if (Object.keys(next).length) return;

    setSubmitting(true);
    try {
      await forgotConfirm(email.trim().toLowerCase(), code.trim(), password);
      navigate('/login');
    } catch (err) {
      const e2 = err as ApiError;
      setErrors({ form: e2.message || 'Could not reset. Check the code and try again.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit}>
      <h1 style={{ marginBottom: 8 }}>Reset password</h1>
      <p style={{ color: 'var(--muted)', marginBottom: 24 }}>Enter the code we just sent, plus your new password.</p>

      <FormField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} error={errors.email} required />
      <FormField label="Code" inputMode="numeric" value={code} onChange={(e) => setCode(e.target.value)} placeholder="123456" error={errors.code} required />
      <FormField label="New password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" hint="At least 12 characters with upper, lower, digit and symbol." error={errors.password} required />

      {errors.form ? <p style={{ color: 'var(--error)', fontSize: 14 }}>{errors.form}</p> : null}
      <Button label="Reset password" type="submit" loading={submitting} style={{ marginTop: 16, width: '100%' }} />
    </form>
  );
}
